import React, { useState, useEffect } from "react";

import "./styles.css";

function Countdown({ target }) {
  const [time, setTime] = useState({
    second: null,
    minute: null,
    hour: null,
    day: null,
  });

  function _countDown() {
    if (target == 0) {
      return {
        second: "0",
        minute: "0",
        hour: "0",
        day: "0",
      };
    }
    const targetTime = target * 1000; // in ms
    const cuur_time = new Date().getTime();
    const left_time = targetTime - cuur_time;

    var day = Math.floor(left_time / (1000 * 60 * 60 * 24))
      .toString()
      .split("");
    var hour = Math.floor((left_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      .toString()
      .split("");
    var minute = Math.floor((left_time % (1000 * 60 * 60)) / (1000 * 60))
      .toString()
      .split("");
    var second = Math.floor((left_time % (1000 * 60)) / 1000)
      .toString()
      .split("");

    return {
      second,
      minute,
      hour,
      day,
    };
  }

  useEffect(() => {
    setTimeout(() => {
      setTime(_countDown());
    }, 1000);
  });
  return (
    <div className="countdown">
      <h3>
        {time.day}
        <span>Days</span>
      </h3>
      <h3>
        {time.hour}
        <span>Hours</span>
      </h3>
      <h3>
        {time.minute}
        <span>Minutes</span>
      </h3>
      <h3>
        {time.second}
        <span>Seconds</span>
      </h3>
    </div>
  );
}

export default Countdown;
